<template>
  <div>
   <section class="step-wizard">
        <ul class="step-wizard-list">
          <li :class="is_step1_active? 'step-wizard-item current-item' : 'step-wizard-item'">
                <span class="progress-count">1</span>
                <span class="progress-label">รับเอกสารนำส่งเงินทุนวิจัย</span>
            </li>
            <li :class="is_step2_active? 'step-wizard-item current-item' : 'step-wizard-item'">
                <span class="progress-count">2</span>
                <span class="progress-label">จัดทำบันทึกนำส่งเงินทุนวิจัย</span>
            </li>
            <li :class="is_step3_active? 'step-wizard-item current-item' : 'step-wizard-item'">
                <span class="progress-count">3</span>
                <span class="progress-label">รอเอกสารจาก ม.มหิดล และ งานคลังคณะฯ</span>
            </li>
            <li :class="is_step4_active? 'step-wizard-item current-item' : 'step-wizard-item'">
                <span class="progress-count">4</span>
                <span class="progress-label">จัดทำบันทึกเบิกเงินทุนวิจัย</span>
            </li>
            <li :class="is_step5_active? 'step-wizard-item current-item' : 'step-wizard-item'">
                <span class="progress-count">5</span>
                <span class="progress-label">เงินเข้าบัญชีโครงการวิจัยแล้ว</span>
            </li>
        </ul>
    </section>
  </div>
</template>

<script>
	export default {
		name: "Step",
		props: ["row"],
    data() {
      return {
        is_step1_active: false,
        is_step2_active: false,
        is_step3_active: false,
        is_step4_active: false,
        is_step5_active: false,
        test: true
      };
    },
    created() {
      if(typeof this.row.step2 === 'undefined') {
        this.is_step2_active = true;
      } else if (typeof this.row.step3 === 'undefined') {
        this.is_step3_active = true;
      } else if (typeof this.row.step4 === 'undefined') {
        this.is_step4_active = true;
      } else if (typeof this.row.step5 === 'undefined') {
        this.is_step5_active = true;
      }
      
    },
	}
	
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=IBM+Plex+Sans+Thai:wght@500&family=Kodchasan:wght@500&family=Noto+Sans+Thai+Looped&family=Sarabun:wght@300&display=swap');
  * {
      margin: 0;
      padding: 0;
      box-sizing: border-box;
  }
  body {
    font-family: 'IBM Plex Sans Thai', sans-serif;
    font-family: 'Kodchasan', sans-serif;
    font-family: 'Noto Sans Thai Looped', sans-serif;
    font-family: 'Sarabun', sans-serif;
  }

  .step-wizard {
      background-color: #ebe8e9;
      background-image: linear-gradient(0deg, #ebe8e9 0%, #105da0 100%);
      height: 30vh;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
  }
  .step-wizard-list{
      background: #fff;
      box-shadow: 0 15px 25px rgba(0,0,0,0.1);
      color: #272929;
      list-style-type: none;
      border-radius: 20px;
      display: flex;
      padding: 20px 10px;
      position: relative;
      z-index: 10;
  }

  .step-wizard-item{
      padding: 0 20px;
      flex-basis: 0;
      -webkit-box-flex: 1;
      -ms-flex-positive:1;
      flex-grow: 1;
      max-width: 100%;
      display: flex;
      flex-direction: column;
      text-align: center;
      min-width: 170px;
      position: relative;
  }
  .step-wizard-item + .step-wizard-item:after{
      content: "";
      position: absolute;
      left: 0;
      top: 19px;
      background: #0c65a0;
      width: 100%;
      height: 2px;
      transform: translateX(-50%);
      z-index: -10;
  }
  .progress-count{
      height: 40px;
      width:40px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      font-weight: 600;
      margin: 0 auto;
      position: relative;
      z-index:10;
      color: transparent;
  }
  .progress-count:after{
      content: "";
      height: 40px;
      width: 40px;
      background: #0c65a0;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      border-radius: 50%;
      z-index: -10;
  }
  .progress-count:before{
      content: "";
      height: 10px;
      width: 20px;
      border-left: 3px solid #fff;
      border-bottom: 3px solid #fff;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -60%) rotate(-45deg);
      transform-origin: center center;
  }
  .progress-label{
      font-size: 14px;
      font-weight: 600;
      margin-top: 10px;
  }
  .current-item .progress-count:before,
  .current-item ~ .step-wizard-item .progress-count:before{
      display: none;
  }
  .current-item ~ .step-wizard-item .progress-count:after{
      height:10px;
      width:10px;
  }
  .current-item ~ .step-wizard-item .progress-label{
      opacity: 0.5;
  }
  .current-item .progress-count:after{
      background: #fff;
      border: 2px solid #0c65a0;
  }
  .current-item .progress-count{
      color: #0c65a0;
  }

  .ul ,li {

    font-family: 'IBM Plex Sans Thai', sans-serif;
    font-family: 'Kodchasan', sans-serif;
    font-family: 'Noto Sans Thai Looped', sans-serif;
    font-family: 'Sarabun', sans-serif;
  

  }
</style>